import { Controller } from "@hotwired/stimulus"

// Group select-all for the therapist treatments form: a global "select all"
// plus a per-category toggle, each reflecting an indeterminate state when only
// some of their items are checked.
export default class extends Controller {
  static targets = ["all", "section", "item"]

  connect() {
    this.refresh()
  }

  toggleAll() {
    const checked = this.allTarget.checked
    this.itemTargets.forEach((item) => { item.checked = checked })
    this.refresh()
  }

  toggleSection(event) {
    const section = event.target.dataset.section
    const checked = event.target.checked
    this.itemsIn(section).forEach((item) => { item.checked = checked })
    this.refresh()
  }

  // Bound to each item's change event.
  refresh() {
    this.sectionTargets.forEach((box) => {
      const items = this.itemsIn(box.dataset.section)
      this.applyState(box, items)
    })
    if (this.hasAllTarget) this.applyState(this.allTarget, this.itemTargets)
  }

  applyState(box, items) {
    const checked = items.filter((i) => i.checked).length
    box.checked = items.length > 0 && checked === items.length
    box.indeterminate = checked > 0 && checked < items.length
  }

  itemsIn(section) {
    return this.itemTargets.filter((item) => item.dataset.section === section)
  }
}
